export default "__VITE_ASSET__f7221d2c__"